module.exports = __webpack_public_path__ + "static/media/digitalmenu_logo.0901dab2.png";